module.exports = __webpack_public_path__ + "img/ranking.a32b05e6.svg";